<template>
  <v-card style="font-family: Microsoft JhengHei">
    <v-card-title class="indigo darken-1" dark>
      <h2>
        <font style="color: white">Note</font>
      </h2>
    </v-card-title>
    <v-container>
      <v-card-title>
        <h3>{{ noteItem.title }}</h3>
      </v-card-title>
      <v-card-text>
        <div align="left">
          <ol>
            <li
              v-for="(
                contentResult, contentResultIndex
              ) in noteItem.contentArray"
              :key="contentResultIndex"
            >
              {{ contentResult }}
            </li>
          </ol>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="teal" @click="handleSave('init')" dark>
          <v-avatar left> <v-icon>mdi-folder-plus</v-icon> </v-avatar>New One
        </v-btn>

        <v-btn color="teal" @click="handleSave('continue')" dark>
          <v-avatar left> <v-icon>mdi-clipboard-file</v-icon> </v-avatar>Resume
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

        <!--<v-row dense
          v-for="(contentResult , contentResultIndex) in noteItem.contentArray"
          :key="contentResultIndex">
          <v-col col="12">
              contentResultIndex+1 .  contentResult
          </v-col>
        </v-row>-->
<script>
export default {
  name: "note-view",
  props: {
    noteItem: {},
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      //   console.log("1");
      this.$emit("childDialog");
    },
    handleSave(value) {
      this.$emit("update-item", value);
    },
  },
};
</script>
